export const PASSWORD_MIN_LENGTH = 6;

export function getPasswordChecks(password) {
    const value = password || '';
    const characterTypes = [
        /[a-z]/.test(value),
        /[A-Z]/.test(value),
        /\d/.test(value),
        /[^A-Za-z0-9\s]/.test(value),
    ];

    return {
        hasMinimumLength: value.length >= PASSWORD_MIN_LENGTH,
        characterTypeCount: characterTypes.filter(Boolean).length,
        hasEnoughVariation: characterTypes.filter(Boolean).length >= 2,
    };
}

export function validateUsername(username) {
    const value = username?.trim() || '';
    if (!value) return 'Enter your username.';
    if (value.length < 3) return 'Username must be at least 3 characters.';
    return '';
}

export function validateEmail(email) {
    const value = email?.trim() || '';
    if (!value) return 'Enter your email address.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        return 'Enter a valid email address, for example name@example.com.';
    }
    return '';
}

export function validatePassword(password) {
    if (!password) return 'Enter a password.';

    const checks = getPasswordChecks(password);
    if (!checks.hasMinimumLength) {
        return `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`;
    }
    if (!checks.hasEnoughVariation) {
        return 'Use at least two types: lowercase, uppercase, numbers, or symbols.';
    }
    return '';
}

export function validateLogin(values) {
    return {
        username: values.username?.trim() ? '' : 'Enter your username.',
        password: values.password ? '' : 'Enter your password.',
    };
}

export function validateRegistration(values) {
    return {
        username: validateUsername(values.username),
        email: validateEmail(values.email),
        password: validatePassword(values.password),
        newsletterConsent: values.newsletterConsent
            ? ''
            : 'Confirm that you agree to receive the newsletter.',
    };
}

export function hasErrors(errors) {
    return Object.values(errors).some(Boolean);
}

export function mapRegistrationError(message = '') {
    const normalized = message.toLowerCase();

    if (normalized.includes('name already exists')) {
        return { username: 'This username is already taken. Try another one.' };
    }
    if (normalized.includes('email already exists')) {
        return { email: 'An account already uses this email address.' };
    }
    if (normalized.includes('username')) {
        return { username: 'Username must be at least 3 characters.' };
    }
    if (normalized.includes('email')) {
        return { email: 'Enter a valid email address, for example name@example.com.' };
    }
    if (normalized.includes('password')) {
        return { password: 'Use 6 or more characters and at least two character types.' };
    }

    return {
        form: message || 'We could not create your account. Please try again.',
    };
}
